import React from 'react';
import ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import App from './App';
import './userSelect.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF6A00', // Bright Cap Barbell orange (matches logo)
      dark: '#E85E00',
      light: '#FF8533',
    },
    secondary: {
      main: '#1A1A1A', // Cap Barbell black
      light: '#333333',
    },
    background: {
      default: '#F5F5F5',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
